import {
  UsersAuthzGroupPermissionDto,
  useUsersAuthzGetManagedPermissionsPermissionsOfGroup,
  useUsersAuthzGetPermissionsCatalog,
  useUsersAuthzResetGroupPermissionsManagedPermissions,
} from '@mi-front/api-v2';
import { Group } from '@mi-front/core';
import { useQueryClient } from '@tanstack/react-query';
import { ActionPermissionsView, PermissionItemComponentProps } from './ActionPermissionsView';
import { GroupPermissionItem } from './GroupPermissionItem';

interface Props {
  readonly group: Group;
}

/**
 * Admin view to list and reset managed action permissions for a group.
 */
export function GroupActionPermissionsView(p: Props) {
  const { group } = p;

  const queryClient = useQueryClient();

  const permissionsCatalogQuery = useUsersAuthzGetPermissionsCatalog();
  const groupPermissionsQuery = useUsersAuthzGetManagedPermissionsPermissionsOfGroup(group.id);

  const GroupPermissionItemWrapper = (
    props: PermissionItemComponentProps<UsersAuthzGroupPermissionDto>,
  ) => <GroupPermissionItem {...props} groupId={group.id} />;

  const resetMutation = useUsersAuthzResetGroupPermissionsManagedPermissions();

  return (
    <ActionPermissionsView
      catalog={permissionsCatalogQuery.data}
      permissions={groupPermissionsQuery.data?.permissions}
      PermissionItemComponent={GroupPermissionItemWrapper}
      isLoading={permissionsCatalogQuery.isLoading || groupPermissionsQuery.isLoading}
      error={permissionsCatalogQuery.error || groupPermissionsQuery.error}
      onReset={async () => {
        await resetMutation.mutateAsync({
          groupId: group.id,
        });

        queryClient.invalidateQueries({
          queryKey: groupPermissionsQuery.queryKey,
        });
      }}
    />
  );
}
